import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Modal, Space } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { PDFViewer } from '../../components/design/PDFviewer';
import { getFileExtension, getFilePath, getPreviewUrl, isImagePreviewType, isShowable } from "../../library/constants";
import { formatDateTime } from '../../library/utils/intl.js';
import style from './received-artwork.module.scss';

const DocumentsDownloader = ({ image, name, comment, project_id, itemId, containerStyles, uploadedAt }) => {
    const [isModalOpen, setisOpen] = useState(false)
    const fileType = getFileExtension(image)
    const isPreviewable = isShowable(image)
    const isImagePreview = isImagePreviewType(fileType)
    const modalBodyStyles = { padding: 0, display: 'flex', justifyContent: 'center' }
    const modalWidth = isImagePreview ? 'fit-content' : 'min(92vw, 1100px)'
    const modalStyles = { maxWidth: 'calc(100vw - 32px)', width: modalWidth }

    return (
        <div className={style.itemDetail} style={containerStyles}>
            <div className={style.bottomButton}>
                <img src={getPreviewUrl(image, project_id, itemId)} alt={name} className={style.imageBox} />
                <div className={style.imageName}>
                    <h4>{name}</h4>
                    {!!uploadedAt && <p style={{ color: '#8c8c8c', fontSize: '0.8rem', margin: '0 0 4px' }}>{formatDateTime(uploadedAt)}</p>}
                    {comment != undefined && <p><b>Comment</b> : {comment}</p>}
                    <Space.Compact className={style.actionButtons}>
                        <Link reloadDocument to={getFilePath(image, project_id, itemId)} download="image.png"> <Button icon={<DownloadOutlined />} >Download</Button> </Link>
                        {isPreviewable && <Button icon={<EyeOutlined />} onClick={() => { setisOpen(true) }}>View</Button>}
                    </Space.Compact>
                </div>
            </div>
            <Modal title="Preview" open={isModalOpen} onCancel={() => { setisOpen(false) }} footer={<Button onClick={() => { setisOpen(false) }} >Close</Button>} width={modalWidth} style={modalStyles} bodyStyle={modalBodyStyles} centered>
                <PDFViewer item_id={itemId} path={image} project_id={project_id} type={fileType} />
            </Modal>
        </div>
    )
}

DocumentsDownloader.propTypes = {
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    comment: PropTypes.string,
    project_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    itemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    containerStyles: PropTypes.object,
    uploadedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default DocumentsDownloader
